export default __webpack_public_path__ + "static/media/construction.4cbc3358.jpg";